import { IconChevronRight16 } from '@cian/ui-kit/icons';
import * as React from 'react';
import * as styles from './ArrowLink.css';

export interface ILinkButtonProps {
  children: React.ReactNode;
  url: string;
  onClick?(e: React.MouseEvent<HTMLElement>): void;
}

export function ArrowLink({ children, url, onClick }: ILinkButtonProps) {
  return (
    <a className={styles['container']} href={url} onClick={onClick} target="_blank" rel="noreferrer noopener">
      <span className={styles['content']}>{children}</span>
      <span className={styles['icon']}>
        <IconChevronRight16 color="primary_100" />
      </span>
    </a>
  );
}
